import { z } from 'zod';
import { templateDialectSchema } from './data-connection-queries.js';

const agentDataQueryBaseQuerySchema = z.object({
  id: z.uuid(),
  name: z.string(),
  description: z.string(),
  dataConnectionId: z.uuid(),
  dataConnection: z.object({
    identifier: z.uuid(),
    name: z.string(),
  }),
});

const agentDataQueryKindSchema = z.discriminatedUnion('queryKind', [
  z.object({
    queryKind: z.literal('template'),
    templateDialect: templateDialectSchema,
  }),
  z.object({
    queryKind: z.literal('guided'),
  }),
]);

export const agentDataQueryRecordSchema = z.object({
  id: z.uuid(),
  agentId: z.coerce.number(),
  brandId: z.coerce.number().nullable(),
  dataConnectionQueryId: z.uuid(),
  isEnabled: z.boolean(),
  addedBy: z.coerce.number().nullable(),
  addedOn: z.coerce.date(),
  query: z.intersection(agentDataQueryBaseQuerySchema, agentDataQueryKindSchema),
});

export type AgentDataQueryRecord = z.infer<typeof agentDataQueryRecordSchema>;
